import WebClient from '@services/utils/WebClient';

import { type IGetPostalCodeInputData } from './dtos/get/InputData';
import { type IGetPostalCodeOutputData } from './dtos/get/OutputData';
import { type IPostalCodeRepository } from './IPostalCodeRepository';

interface IGetResponse {
  city: string;
  neighborhood: string;
  postal_code: string;
  state: string;
  street: string;
}

class PostalCodeService implements IPostalCodeRepository {
  public async get(
    inputData: IGetPostalCodeInputData,
  ): Promise<IGetPostalCodeOutputData> {
    const response = await WebClient.get<IGetResponse>({
      path: `utils/postal-code/${inputData.postalCode}`,
    });
    const output: IGetPostalCodeOutputData = {
      city: response.data.city,
      neighborhood: response.data.neighborhood,
      postalCode: response.data.postal_code,
      state: response.data.state,
      street: response.data.street,
    };
    return output;
  }
}

export default new PostalCodeService();
